import React, { Ref } from "react";
import {
  Text,
  Button,
  Spacing,
  XLTextInput,
  TextInputType,
} from "@valkdigital/ui-kit";
import { Image, StyleSheet, Dimensions } from "react-native";
import KeyboardAvoidedView from "../../../components/KeyboardAvoidedView";
import { useTranslation } from "react-i18next";

interface GiftcardPinScreenProps {
  inputRef: Ref<TextInputType>;
  onCodeChange: (text: string) => void;
  code: string;
  proceed: () => void;
  isLoading: boolean;
  isValid: boolean;
}

const GiftcardPinScreen: React.FC<GiftcardPinScreenProps> = ({
  inputRef,
  onCodeChange,
  code,
  proceed,
  isLoading,
  isValid,
}) => {
  const { t } = useTranslation();

  return (
    <KeyboardAvoidedView style={styles.container}>
      <Text type="h3" style={styles.title}>
        {t("guest.payment.giftcard.pin")}
      </Text>

      <Image
        source={require("../../../../assets/images/valk-cadeaucard-pin.png")}
        style={styles.image}
      />

      <XLTextInput
        ref={inputRef}
        onChangeText={onCodeChange}
        value={code}
        keyboardType="number-pad"
        placeholder="••••••"
        textAlign="center"
        containerStyle={styles.input}
      />

      <Button
        label={t("ui.proceed")}
        disabled={!isValid || isLoading}
        loading={isLoading}
        onPress={proceed}
        size="full"
      />
    </KeyboardAvoidedView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "space-between",
    paddingTop: Spacing.sp2,
  },
  image: {
    width: "100%",
    height: Dimensions.get("window").height * 0.33,
    resizeMode: "contain",
    alignSelf: "center",
  },
  title: {
    paddingHorizontal: Spacing.sp2,
  },
  input: {
    paddingHorizontal: Spacing.sp2,
  },
});

export default GiftcardPinScreen;
